import { render, staticRenderFns } from "./ArticleEdit.vue?vue&type=template&id=e60fc256&scoped=true&"
import script from "./ArticleEdit.vue?vue&type=script&lang=js&"
export * from "./ArticleEdit.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./ArticleEdit.vue?vue&type=style&index=1&id=e60fc256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60fc256",
  null
  
)

export default component.exports